import { MENU_ITEMS } from '../../layout/constants/layoutConstants';

const PRIMARY_GRADIENTS = [
  'linear-gradient(135deg, #5e894f 0%, #4a6d3e 100%)',
  'linear-gradient(135deg, #5e894f 0%, #3e5a32 100%)',
  'linear-gradient(135deg, #73a362 0%, #5e894f 100%)',
  'linear-gradient(135deg, #5e894f 0%, #6b9c5a 100%)',
  'linear-gradient(135deg, #8bb77e 0%, #5e894f 100%)',
  'linear-gradient(135deg, #5e894f 0%, #52774a 100%)',
  'linear-gradient(135deg, #a8d49a 0%, #5e894f 100%)',
  'linear-gradient(135deg, #5e894f 0%, #466145 100%)',
  'linear-gradient(135deg, #7ba76c 0%, #5e894f 100%)',
  'linear-gradient(135deg, #5e894f 0%, #6f9e5f 100%)',
  'linear-gradient(135deg, #9bc88c 0%, #5e894f 100%)',
  'linear-gradient(135deg, #5e894f 0%, #588445 100%)',
  'linear-gradient(135deg, #6ea25e 0%, #5e894f 100%)',
  'linear-gradient(135deg, #5e894f 0%, #4f7341 100%)',
  'linear-gradient(135deg, #85b876 0%, #5e894f 100%)',
];

/**
 * Obtiene un gradiente consistente para una ruta específica
 * @param {string} path - Ruta de la página
 * @returns {string} Gradiente CSS
 */
export const getConsistentGradient = (path) => {
  let hash = 0;
  for (let i = 0; i < path.length; i++) {
    const char = path.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  const index = Math.abs(hash) % PRIMARY_GRADIENTS.length;
  return PRIMARY_GRADIENTS[index];
};

/**
 * Genera cards dinámicamente desde los elementos del menú
 * @param {Function} hasModule - Función para verificar permisos de módulo
 * @param {Array} mostVisitedPages - Array de páginas más visitadas (opcional)
 * @returns {Array} - Array de cards generadas dinámicamente
 */
export const generateDynamicCards = (hasModule, mostVisitedPages = []) => {
  const cards = [];

  const processMenuItem = (item, parentPath = '') => {
    if (item.path && item.requiredModule && hasModule(item.requiredModule)) {
      const fullPath = parentPath + item.path;
      const normalizedPath = fullPath.startsWith('/') ? fullPath : `/${fullPath}`;

      const visitData = mostVisitedPages.find((page) => page.path === normalizedPath);

      cards.push({
        title: item.label,
        description: `Acceso a ${item.label.toLowerCase()}`,
        icon: item.icon,
        path: normalizedPath,
        color: getConsistentGradient(normalizedPath),
        requiredModule: item.requiredModule,
        visitCount: visitData?.count || 0,
        lastVisited: visitData?.lastVisited || 0,
      });
    }

    if (item.children) {
      item.children.forEach((child) => {
        processMenuItem(child, parentPath);
      });
    }
  };

  MENU_ITEMS.forEach((item) => {
    processMenuItem(item);
  });

  return cards;
};

/**
 * Mezcla un array de forma aleatoria (algoritmo Fisher-Yates)
 * @param {Array} array - Array a mezclar
 * @returns {Array} - Array mezclado
 */
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/**
 * Ordena las cards por popularidad basándose en las visitas
 * @param {Array} cards - Array de cards
 * @returns {Array} - Array de cards ordenadas por popularidad
 */
export const sortCardsByPopularity = (cards) => {
  return [...cards].sort((a, b) => {
    if (b.visitCount !== a.visitCount) {
      return b.visitCount - a.visitCount;
    }
    if (b.lastVisited !== a.lastVisited) {
      return b.lastVisited - a.lastVisited;
    }
    return a.title.localeCompare(b.title);
  });
};

export const HOME_STYLES = {
  container: {
    bgcolor: 'whitesmoke',
    py: { xs: 3, md: 7 },
    px: { xs: 2, md: 10 },
    minHeight: '92vh',
  },
  avatar: {
    width: 64,
    height: 64,
    bgcolor: 'primary.main',
    fontSize: '1.5rem',
  },
  logoutButton: {
    bgcolor: 'error.light',
    color: 'white',
    '&:hover': { bgcolor: 'error.main' },
    p: 2,
  },
  card: {
    cursor: 'pointer',
    height: '100%',
    color: 'white',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'translateY(0px)',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.2)',
    },
  },
};
